import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import React from "react";
import {
  closeDialog,
  openDialog,
} from "../../../components/dialog/dialogSlice";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import AppDialog, {
  DialogCloseButton,
} from "../../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import IconButton from "../../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import FormTextField from "../../../components/formFields/FormTextField";
import {
  requiredValidator,
  skipValidator,
} from "../../../components/formFields/CommonValidator";
import { setAccomodationDeleteIndex } from "../quotationSlice";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { IRoomType } from "../../roomtype/roomTypeModel";
import { IMealType } from "../../mealtype/mealtypeModel";
import FormNumericTextField from "../../../components/formFields/FormNumericTextField";

const QuotationAccomodationArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const dispatch = useAppDispatch();
  const AccomodationDeleteIndex = useAppSelector(
    (state) => state.quotation.AccomodationDeleteIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const RoomTypeList = useAppSelector((state) => state.roomType.RoomTypeList);
  const MealTypeList = useAppSelector((state) => state.mealType.MealTypeList);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("accomodationDeleteDialog"));
    dispatch(setAccomodationDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setAccomodationDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        Place: "",
        Hotel: "",
        CheckInDate: "",
        CheckOutDate: "",
        RoomTypeID: null,
        MealTypeID: null,
        TotalRoom: null,
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {!fieldArrayRenderProps.value || fieldArrayRenderProps?.value?.length < 1
        ? pushElementInarray()
        : null}
      {dialogName === "accomodationDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Accomodation"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(AccomodationDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map(
          (Accommodations: any, index: number) => (
            <GridLayoutItem key={index}>
              <Card className="fieldarray-card">
                <GridLayout
                  style={{ marginRight: 40 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      name={`Accommodations.${index}.Place`}
                      label="Place"
                      placeholder="Place"
                      component={FormTextField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Hotel ||
                        fieldArrayRenderProps?.value[index]?.CheckInDate ||
                        fieldArrayRenderProps?.value[index]?.CheckOutDate ||
                        fieldArrayRenderProps?.value[index]?.RoomTypeID ||
                        fieldArrayRenderProps?.value[index]?.MealTypeID ||
                        fieldArrayRenderProps?.value[index]?.TotalRoom
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Accommodations.${index}.Hotel`}
                      label="Hotel"
                      placeholder="Hotel"
                      component={FormTextField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.CheckInDate ||
                        fieldArrayRenderProps?.value[index]?.CheckOutDate ||
                        fieldArrayRenderProps?.value[index]?.RoomTypeID ||
                        fieldArrayRenderProps?.value[index]?.MealTypeID ||
                        fieldArrayRenderProps?.value[index]?.TotalRoom
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Accommodations.${index}.CheckInDate`}
                      label="Check In Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.Hotel ||
                        fieldArrayRenderProps?.value[index]?.CheckOutDate ||
                        fieldArrayRenderProps?.value[index]?.RoomTypeID ||
                        fieldArrayRenderProps?.value[index]?.MealTypeID ||
                        fieldArrayRenderProps?.value[index]?.TotalRoom
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Accommodations.${index}.CheckOutDate`}
                      label="Check Out Date"
                      format="dd/MM/yyyy"
                      minDate={moment(
                        fieldArrayRenderProps.formRenderProps.valueGetter(
                          `Accommodations.${index}.CheckInDate`
                        )
                      ).toDate()}
                      component={FormDatePicker}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.Hotel ||
                        fieldArrayRenderProps?.value[index]?.CheckInDate ||
                        fieldArrayRenderProps?.value[index]?.RoomTypeID ||
                        fieldArrayRenderProps?.value[index]?.MealTypeID ||
                        fieldArrayRenderProps?.value[index]?.TotalRoom
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Accommodations.${index}.RoomTypeID`}
                      label="Room Type"
                      placeholder="Room Type"
                      component={FormSelectionField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.Hotel ||
                        fieldArrayRenderProps?.value[index]?.CheckInDate ||
                        fieldArrayRenderProps?.value[index]?.CheckOutDate ||
                        fieldArrayRenderProps?.value[index]?.MealTypeID ||
                        fieldArrayRenderProps?.value[index]?.TotalRoom
                          ? requiredValidator
                          : skipValidator
                      }
                      options={RoomTypeList.map((roomtype: IRoomType) => {
                        return {
                          value: roomtype?.ID,
                          label: roomtype?.RoomType,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Accommodations.${index}.MealTypeID`}
                      label="Meal Type"
                      placeholder="Meal Type"
                      component={FormSelectionField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.Hotel ||
                        fieldArrayRenderProps?.value[index]?.CheckInDate ||
                        fieldArrayRenderProps?.value[index]?.CheckOutDate ||
                        fieldArrayRenderProps?.value[index]?.RoomTypeID ||
                        fieldArrayRenderProps?.value[index]?.TotalRoom
                          ? requiredValidator
                          : skipValidator
                      }
                      options={MealTypeList.map((mealtype: IMealType) => {
                        return {
                          value: mealtype?.ID,
                          label: mealtype?.MealType,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field"
                      name={`Accommodations.${index}.TotalRoom`}
                      label="Total Room"
                      placeholder="0"
                      max={50}
                      component={FormNumericTextField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.Hotel ||
                        fieldArrayRenderProps?.value[index]?.CheckInDate ||
                        fieldArrayRenderProps?.value[index]?.CheckOutDate ||
                        fieldArrayRenderProps?.value[index]?.RoomTypeID ||
                        fieldArrayRenderProps?.value[index]?.MealTypeID
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem className="text-end">
                    <IconButton
                      onClick={() => handleOpenDeleteDialog(index)}
                      disabled={fieldArrayRenderProps.value.length === 1}
                      themeColor={"error"}
                      size={"small"}
                      fillMode={"solid"}
                      type="button"
                      style={{
                        height: 30,
                        width: 30,
                        marginTop: 35,
                      }}
                      icon={MdDelete}
                      iconClassName="absolute-position"
                      iconStyle={{ fontSize: "16px" }}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </Card>
            </GridLayoutItem>
          )
        )}

      <GridLayoutItem style={{ textAlign: "end" }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Accomodation
        </Button>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default QuotationAccomodationArray;
